@if (path) {
    <a
        class="side-menu-child"
        [class.side-menu-child--active]="active"
        [href]="path"
        [attr.tabindex]="linkTabIndex"
    >
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
} @else {
    <div class="side-menu-child" [class.side-menu-child--active]="active">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
}

<ng-template #content>
    <div class="side-menu-child__indicator"></div>
    <div
        class="side-menu-child__label"
        [class.side-menu-child__label--is-grand-child]="isGrandChild"
        [class.side-menu-child__label--is-orphan]="isOrphan"
    >
        {{ label }}
        @if (badge && badge.value) {
            <nw-pill
                class="side-menu-child__label__pill"
                [nwAddAttributes]="badge.attributes"
                >{{ badge.value }}</nw-pill
            >
        }
    </div>
    <ng-container #dynamicContainer></ng-container>
</ng-template>
